import './view.scss';

(function () {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }

    function updateParallax() {
        const sections = document.querySelectorAll('.cta-banner');
        if (!sections.length) return;

        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

        sections.forEach((section) => {
            const rect = section.getBoundingClientRect();
            if (rect.bottom < 0 || rect.top > viewportHeight) {
                return;
            }

            const relativeProgress = (viewportHeight / 2 - (rect.top + rect.height / 2)) / viewportHeight;

            const items = section.querySelectorAll('.fg-image-container');
            items.forEach((el) => {
                const speed = parseFloat(el.getAttribute('data-parallax-speed') || '0');
                if (!speed) return;

                const translateY = relativeProgress * speed * -150;
                el.style.transform = `translate3d(0, ${translateY}px, 0)`;
            });
        });
    }

    let ticking = false;
    function onScrollOrResize() {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateParallax();
                ticking = false;
            });
            ticking = true;
        }
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        updateParallax();
    } else {
        document.addEventListener('DOMContentLoaded', updateParallax);
    }
})();
